import { Stack, CircularProgress as MuiCircularProgress } from '@mui/material';

export default function CircularProgress() {
  return (
    <Stack alignItems="center">
      <MuiCircularProgress />
    </Stack>
  );
}

